var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
var MediaService = services.MediaService;
import { loadFoldersRequest, loadFoldersSuccess, loadFoldersFailure, deleteFileRequest, deleteFileSuccess, deleteFileFailure, saveFileRequest, saveFileFailure, loadFilesRequest, loadFilesSuccess, loadFilesFailure, uploadFileRequest, uploadFileSuccess, setSelectedFile, saveFileSuccess, updateErrorSavingFileState, } from './reducer';
export var getFiles = function (scope) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, meta, files, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch(loadFilesRequest());
                    return [4 /*yield*/, MediaService.getFiles(scope)];
                case 1:
                    _a = _b.sent(), meta = _a.meta, files = _a.objects;
                    dispatch(loadFilesSuccess({ files: files.reverse(), meta: meta }));
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _b.sent();
                    console.log(err_1);
                    dispatch(loadFilesFailure());
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteFile = function (fileId, scope) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch(deleteFileRequest());
                return [4 /*yield*/, MediaService.deleteFile(fileId)];
            case 1:
                _a.sent();
                dispatch(getFiles(scope));
                dispatch(deleteFileSuccess());
                return [3 /*break*/, 3];
            case 2:
                err_2 = _a.sent();
                dispatch(deleteFileFailure());
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var saveFile = function (uploadingFileId, file, folderId, scope) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, response, err, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 6]);
                    dispatch(saveFileRequest());
                    return [4 /*yield*/, MediaService.saveFile(file.name, file.type, null, folderId, scope)];
                case 1:
                    result = (_a.sent()).object;
                    return [4 /*yield*/, MediaService.uploadToS3(result.url, file, result.mime_type)];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        dispatch(uploadFileSuccess({ file: result, id: uploadingFileId }));
                        dispatch(setSelectedFile(result));
                        dispatch(saveFileSuccess());
                        return [2 /*return*/, result];
                    }
                    err = { fileId: result.id };
                    throw err;
                case 3:
                    err_3 = _a.sent();
                    if (!err_3.fileId) return [3 /*break*/, 5];
                    return [4 /*yield*/, MediaService.deleteFile(err_3.fileId)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    dispatch(saveFileFailure(uploadingFileId));
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, null];
            }
        });
    }); };
};
export var getFolders = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, meta, folders, err_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch(loadFoldersRequest());
                return [4 /*yield*/, MediaService.getFolders()];
            case 1:
                _a = _b.sent(), meta = _a.meta, folders = _a.objects;
                dispatch(loadFoldersSuccess({ folders: folders, meta: meta }));
                return [3 /*break*/, 3];
            case 2:
                err_4 = _b.sent();
                dispatch(loadFoldersFailure(err_4));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var setFilesBeforeUpload = function (files) {
    if (files === void 0) { files = []; }
    return function (dispatch) {
        dispatch(uploadFileRequest(files));
    };
};
export var updateErrorSavingFile = function (errorSavingFile) { return function (dispatch) {
    dispatch(updateErrorSavingFileState(errorSavingFile));
}; };
